// extracted by mini-css-extract-plugin
export default {"container":"ForgotPasswordPage_container__RO-Dx","body":"ForgotPasswordPage_body__JrAKV"};